<div style="display: flex;flex-direction: column;min-height: inherit;">
    <div matDialogTitle>
        <div style="width: calc(100% - 30px);">
            <span>{{title}}</span>
        </div>
        <button *ngIf="!hideClose" type="button" tabindex="-1" style="position: relative;right: 0px;width: 30px;height: 30px;margin-left: 0px; min-width: unset;padding: 0px;line-height: normal;"
        id="easy-form-close-btn" class="easy-form-close-btn" mat-button  (click)="close()">
            <mat-icon style="color: #ddd; font-size: 20px;margin-top: 5px;">close</mat-icon>
        </button>
    </div>
    <div matDialogContent style="flex-grow: 1; ">
        <div class="p-3" style="display:flex;flex-direction: column;">
            <app-vis-grid appLocalPageBar [localPageSource]="gridView"  [size]="pageSize">
                <ng-container *ngFor="let item of headerAry">
                    <app-vis-grid-column *ngIf="!item.click;else btnTmp" [title]="item.title" [field]="item.field" [width]="item.width"></app-vis-grid-column>    
                    <ng-template #btnTmp>
                        <app-vis-grid-column [title]="item.title" [field]="item.field" [width]="item.width">
                            <ng-template let-data let-row="index">
                                <button (click)="item.click(gridData[row])">{{data[item.field]}}</button>
                            </ng-template>
                        </app-vis-grid-column>    
                    </ng-template>
                </ng-container>
                
            </app-vis-grid>
        </div>
        <div class="px-4 text-center">
            <button type="button" class="easy-form-btn sumbit vis-btn-primary mb-1 vis-btn-capsule mx-1" (click)="close()">關閉</button>
        </div>
    </div>
</div>
